import apiClient from './apiClient';

export const fastDomainCheckApi = (data) => {
  return apiClient.post('/admin/fast-domain-check', data);
};

export const getScansApi = (params) => {
  return apiClient.get('/admin/scans', { params });
};

export const getOemScansApi = (params) => {
  return apiClient.get('/partners/oem-partners/scan/list', { params });
};